import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import moment from 'moment'
import Modal from '../../../../components/Modal'
import Feedback from '../../../../components/feedback'
import { Button } from '../../../../components/ui/button'
import Badge from '../../../../components/ui/badge'
import { Title, Text1Bold, Text2, LinkText } from '../../../../components/ui/text'
import { Success, Calendar, ErrorIcon } from '../../../../assets/icons'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'
import { capitalizeEachWord } from '../../../../utils/stringsUtils'
import { buildAppointmentCalendarEvent } from '../../../../utils/appointmentCalendarEvent'
import AddToCalendarQuickAccessModal from '../../../../components/AddToCalendarQuickAccessModal'
import { Container, HeaderSection, CardsGrid, Card, CardInfo, ButtonWrapper } from './styled'

const MultipleAppointmentsSuccess = ({ cartTurns, clinics, result, onRetry }) => {
	const history = useHistory()
	const isMobile = useIsMobile()
	const [calendarEvent, setCalendarEvent] = useState(null)
	const [selectedErrorMessage, setSelectedErrorMessage] = useState(null)

	const turns = cartTurns || []
	const turnResults = result?.turns || []
	const getTurnResult = turn => turnResults.find(r => r.idTurno === turn.idTurno)
	const isTurnError = turn => !!getTurnResult(turn)?.hasError
	const getTurnErrorMessage = turn => getTurnResult(turn)?.errorMessage || 'Error al agendar el turno'
	const hasErrors = turnResults.some(r => r.hasError)

	const getClinicName = turn =>{
		return clinics?.find(clinic => clinic.value === turn.clinica)?.label
	}

	const getClinicDireccion = turn => turn.direccion

	const formatDate = turn => {
		const date = moment(turn.fechaTurnoDateTime)
		return date.isValid() ? date.format('DD/MM/YYYY') : ''
	}

	const formatTime = turn => {
		const date = moment(turn.fechaTurnoDateTime)
		return date.isValid() ? date.format('HH:mm') : ''
	}

	return (
		<>
			<AddToCalendarQuickAccessModal
				isOpen={!!calendarEvent}
				onClose={() => setCalendarEvent(null)}
				isFullHeight={isMobile}
				event={calendarEvent}
			/>
			{selectedErrorMessage && (
				<Modal
					onClose={() => setSelectedErrorMessage(null)}
					isFullHeight={isMobile}
					widthDesktop="440px"
				>
					<Feedback
						title="Error al agendar el turno"
						//por ahora no muestra mensaje del back
						// bodyText={selectedErrorMessage}
						bodyText="Ocurrió un error al agendar el turno"
						buttonLabel="Cerrar"
						onClickButton={() => setSelectedErrorMessage(null)}
						isSucces={false}
						isError={true}
						icon={<ErrorIcon color={theme.colors.feedback.error} />}
						isModal={true}
						pt={80}
						widthDesktop="440px"
					/>
				</Modal>
			)}
			<Container>
				<HeaderSection>
					{hasErrors ? (
						<ErrorIcon size={64} color={theme.colors.feedback.error} />
					) : (
						<Success size={64} color={theme.colors.brand.green} />
					)}
					<Title
						size={isMobile ? '22px' : '28px'}
						color={theme.colors.text.primaryText}
						align="center"
						margin="16px 0 8px 0"
					>
						{hasErrors
							? 'No se pudieron agendar todos los turnos'
							: '¡Tus turnos fueron agendados con éxito!'}
					</Title>
					<Text2 color={theme.colors.text.secondaryText} align="center">
						{hasErrors
							? 'Revisá el detalle e intentá nuevamente con los turnos que presentaron errores.'
							: 'Podrás ver los detalles en la pantalla de inicio.'}
					</Text2>
				</HeaderSection>

				<CardsGrid>
					{turns?.map((turn, index) => (
						<Card key={turn.idTurno || index}>
							{isTurnError(turn) ? (
								<Badge variant="error">
									<ErrorIcon size={14} color={theme.colors.feedback.error} />
									<span>Error al agendar el turno</span>
								</Badge>
							) : (
								<Badge variant="success">Agendado</Badge>
							)}
							<CardInfo>
								<Text1Bold size="16px" color={theme.colors.text.primaryText}>
									{capitalizeEachWord(turn.nombreProfesional || '')}
								</Text1Bold>
								<Text2 size="14px" color={theme.colors.text.secondaryText}>
									{[
										capitalizeEachWord(turn.nombreEspecialidad || ''),
										formatDate(turn),
										formatTime(turn)
									]
										.filter(Boolean)
										.join(' • ')}
								</Text2>
								<Text2 size="14px" color={theme.colors.text.secondaryText}>
									{capitalizeEachWord(getClinicName(turn) || '')}
								</Text2>
								<Text2 size="14px" color={theme.colors.text.secondaryText}>
									{capitalizeEachWord(getClinicDireccion(turn) || '')}
								</Text2>
							</CardInfo>
							{isTurnError(turn) ? (
								<LinkText
									size="14px"
									color={theme.colors.brand.blueOmint}
									onClick={() => setSelectedErrorMessage(getTurnErrorMessage(turn))}
								>
									Ver detalle
								</LinkText>
							) : (
								<LinkText
									size="14px"
									color={theme.colors.brand.blueOmint}
									onClick={() => setCalendarEvent(buildAppointmentCalendarEvent(turn))}
								>
									<Calendar size={16} color={theme.colors.brand.blueOmint} />
									<span style={{ marginLeft: '8px' }}>Agregar a mi calendario</span>
								</LinkText>
							)}
						</Card>
					))}
				</CardsGrid>

				<ButtonWrapper>
					{hasErrors ? (
						<>
							<Button
								label="Volver a intentar"
								$variant="primary"
								size={isMobile ? 'mobile' : 'xlarge'}
								onClick={() => onRetry && onRetry()}
								width="359px"
								height="40px"
							/>
							<LinkText
								size="14px"
								color={theme.colors.brand.blueOmint}
								style={{ alignSelf: 'center', marginTop: '16px' }}
								onClick={() => history.push('/inicio')}
								fontWeight="600"
							>
								Volver al inicio
							</LinkText>
						</>
					) : (
						<Button
							label="Volver al inicio"
							$variant="primary"
							size={isMobile ? 'mobile' : 'xlarge'}
							onClick={() => history.push('/inicio')}
						/>
					)}
				</ButtonWrapper>
			</Container>
		</>
	)
}

function mapStateToProps({ appointment }) {
	return {
		cartTurns: appointment.booking.cartTurns,
		clinics: appointment.booking.catalogs.clinics,
		result: appointment.booking.result
	}
}

export default connect(mapStateToProps)(MultipleAppointmentsSuccess)
